import EnlilAxios from "../../../../util/EnlilAxios";
import {sleep} from "../../../../util/Sleep";
import {V1DeveloperLogIDOCToArray} from "../../../../util/Payload";
import EnterpriseComponent from "../../EnterpriseComponent";


class DeveloperLogEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        const send_request = (queryId) =>
            EnlilAxios({
                method: "GET",
                url: "t2/v1/developer_logs",
                json: true,
                params: {
                   "Limit": pageSize,
                    "Offset": (page - 1) * pageSize,
                    ...this.getSearchSpecification(),
                    ...(queryId ? {"QueryID": queryId} : {}),
                },
            }).then(response => {
                if (response.data.CheckComplete === false) {
                    let queryId = response.data.QueryID;
                    sleep(10000).then(() => send_request(queryId));
                } else {
                    this.fetchEnterpriseComponentSuccess(V1DeveloperLogIDOCToArray(response.data), page, pageSize);
                }
            }).catch(error => {
                this.fetchEnterpriseComponentFailed(error);
            });

        send_request();
    };
}

export default DeveloperLogEnterpriseComponent;